import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'
import { API_GEARS } from 'utils/apiList'

const getGearsDetail = createAsyncThunk(
  'gearsList/list',
  async ({ id }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(`${API_GEARS}/${id}`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const updateGear = createAsyncThunk(
  'portsList/update',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.post(
        `${apiEndpoint}/${API_GEARS}/${payload?.id}`,
        payload,
        config,
      )
      return data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  },
)

export { getGearsDetail, updateGear }
